module.exports = __webpack_public_path__ + "img/compass_distance.ff356961.svg";